
import Vue from "vue";
import AppFileUpload from "../FileUploadDropAndProgress.vue";

export default Vue.extend({
	computed: {
		allowedExtensions(): string[] {
			return ["jpg", "pdf", "png", "xlsx", "docx", "csv", "xls"];
		},
	},
	methods: {
		onFile(file: File) {
			if (file.name.length > 128) {
				this.$wf.notify(this.$ct("error-file-name-too-long"), "danger", 3000, "exclamation-triangle");
				return;
			}
			this.$emit("file", file);
		},
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
